import React, { Component } from "react";
import CategoryInput from "../categories/category_input";
import CreateRecommendation from "./create_recommendation";
import CreateRecommendationLink from "./create_recommendation_link";

import { validateURL, checkImageUrl } from "../../helper/helper";
import { renderErrorMessage } from "../../helper/user_helper";
import { createRecommendation } from "../../helper/recommendation_helper";
import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

import Loader from "../loader";
import UploadDiv from "../upload";
let strings = new LocalizedStrings({ en });
class CreateRecommendationPage extends Component {
  state = {
    hashtag: "",
    image: null,
    video: null,
    imageFile: null,
    videoFile: null,
    recommendation: "",
    errors: "",
    question: false,
    percent_upload: 0,
    url: "",
    url_title: "",
    url_description: ""
  };

  componentWillUnmount() {
    if (this.createRecommendationCall) {
      this.createRecommendationCall.cancel();
    }
    if (this.checkUrlCall) {
      this.checkUrlCall.cancel();
    }
  }

  componentDidMount() {
    if (this.props.hashtag) {
      this.setState({ hashtag: this.props.hashtag });
    }
  }

  render() {
    const style = {
      display: "block",
      position: "absolute",
      margin: "0px",
      width: "100%",
      height: "100%",
      paddingBottom: "2px"
    };
    const style_image = {};
    if (this.props.loaded === false) {
      return (
        <div>
          <Loader loaded={this.props.loaded} />
          <UploadDiv percent_upload={this.state.percent_upload} />
        </div>
      );
    }

    return (
      <form className="center" onSubmit={this.createRecommendation}>
        <CategoryInput
          categoryName={this.state.hashtag}
          handleChangeCategoryName={this.handleChangeHashtag}
        />
        <CreateRecommendation
          recommendation={this.state.recommendation}
          handleChangeRecommendation={this.handleChangeRecommendation}
          handleChangeImage={this.handleChangeImage}
          image={this.state.image}
          video={this.state.video}
          imageFile={this.state.imageFile}
          url_title={this.state.url_title}
          url_description={this.state.url_description}
        />
        <CreateRecommendationLink
          url={this.state.url}
          handleChangeURL={this.handleChangeURL}
        />
        <div className="pt-2 row slider_row max_width_500 width_100">
          <div className="slider_col">
            <label>{strings.asking_recommandation}</label>
          </div>
          <div className="slider_col_small">
            <label className="switchOnOff">
              <input
                type="checkbox"
                className=""
                value={this.state.question}
                ischecked={this.state.question.toString()}
                onChange={this.handleChangeQuestion}
              />
              <span className="slider round" />
            </label>
          </div>
        </div>
        {renderErrorMessage(this.state.errors)}

        <div className="row max_width_500 width_100 mt-2">
          <div className="width_image_question" />
          <div className="width_text_question" />
          <div className="width_image_question">
            <div className="user_img" style={style_image}>
              <input
                style={style}
                type="submit"
                value={strings.create_question}
                className="btn btn_primary btn_yaystack no_border"
              />
            </div>
          </div>
        </div>
      </form>
    );
  }

  handleChangeHashtag = hashtag_ => {
    // Only allow lower case hahstag and alpahanumeric
    var hashtag = hashtag_.toLowerCase();
    hashtag = hashtag.replace(/[^a-z0-9_]/gi, "");
    this.setState({ hashtag });
  };

  handleChangeRecommendation = recommendation => {
    this.setState({ recommendation });
  };

  handleChangeQuestion = event => {
    this.setState({ question: !this.state.question });
  };

  handleChangeURL = url => {
    this.setState({ url });
    if (this.checkUrlCall) {
      this.checkUrlCall.cancel();
    }

    if (!url.includes("http://") && !url.includes("https://")) {
      url = "http://" + url;
    }

    if (this.state.imageFile === null && this.state.videoFile === null) {
      this.setState({ image: null });
      if (validateURL(url)) {
        const self = this;
        this.checkUrlCall = checkImageUrl(url);
        this.checkUrlCall.promise
          .then(answer => {
            self.setState({
              image: answer.image,
              url_title: answer.title,
              url_description: answer.description
            });
          })
          .catch(error => {
            self.setState({ errors: error.errors });
          });
      }
    }
  };

  handleChangeImage = event => {
    const errors = "";
    this.setState({ errors });

    if (event.target.files && event.target.files[0]) {
      this.setState({
        image: null,
        imageFile: null,
        video: null,
        videoFile: null
      });
      if (event.target.files[0].type.includes("image/")) {
        let reader = new FileReader();
        reader.onload = e => {
          this.setState({
            image: e.target.result
          });
        };
        this.setState({ imageFile: event.target.files[0] });
        reader.readAsDataURL(event.target.files[0]);
      } else if (event.target.files[0].type.includes("video/")) {
        let reader = new FileReader();
        reader.onload = e => {
          this.setState({
            video: e.target.result
          });
        };
        this.setState({ videoFile: event.target.files[0] });
        reader.readAsDataURL(event.target.files[0]);
      } else {
        // Check format as accept is not working on edge
        const errors = strings.wrong_file;
        this.setState({ errors });
      }
    }
  };

  createRecommendation = event => {
    event.preventDefault();

    const errors = "";
    this.setState({ errors });

    // Checking minimum length of the category
    if (this.state.hashtag.length < 3) {
      const errors = strings.hashtag_too_short;
      this.setState({ errors });
      return;
    }

    // Checking minimum length of the recommendation
    if (this.state.recommendation.length < 8) {
      const errors = strings.recommendation_too_short;
      this.setState({ errors });
      return;
    }

    // Checking that the recommendation doesn't have any URL
    if (
      this.state.recommendation.includes("http://") ||
      this.state.recommendation.includes("https://") ||
      this.state.recommendation.includes("ftp://") ||
      this.state.recommendation.includes("www.")
    ) {
      const errors = strings.url_not_allow;
      this.setState({ errors });
      return;
    }

    if (this.state.url !== "") {
      // Validate URL
      if (!validateURL(this.state.url)) {
        const errors = strings.wrong_url;
        this.setState({ errors });
        return;
      }
    }

    // Checking if video or image present
    if (this.state.image === null && this.state.video === null) {
      const errors = strings.recommendation_img_or_video_missing;
      this.setState({ errors });
      return;
    }

    // Checking maximum size video (100MB)
    if (this.state.video !== null) {
      if (this.state.videoFile) {
        if (this.state.videoFile.size > 100 * 1024 * 1024) {
          const errors = strings.media_too_big;
          this.setState({ errors });
          return;
        }
      } else {
        return;
      }
    }

    if (this.state.image !== null) {
      if (this.state.imageFile) {
        if (this.state.imageFile.size > 100 * 1024 * 1024) {
          const errors = strings.media_too_big;
          this.setState({ errors });
          return;
        }
      } else {
        if (this.state.url) {
          // If image present (meta data image) and url we will create the image from the meta data on the backend side
        } else {
          return;
        }
      }
    }

    this.props.handleUpdateLoaded(false);

    var fd = new FormData();
    fd.append("recommendation[name]", this.state.recommendation);
    fd.append("recommendation[question]", this.state.question);
    fd.append("recommendation[hashtag]", this.state.hashtag);
    if (this.state.image !== null && this.state.imageFile !== null) {
      fd.append("recommendation[image]", this.state.imageFile);
    }
    if (this.state.video !== null && this.state.videoFile !== null) {
      fd.append("recommendation[video]", this.state.videoFile);
    }
    if (this.state.url !== "") {
      var url = this.state.url;
      if (!url.includes("http://") && !url.includes("https://")) {
        url = "http://" + url;
      }
      fd.append("recommendation[url]", url);
    }

    const self = this;
    this.createRecommendationCall = createRecommendation(fd);
    this.createRecommendationCall.promise
      .then(answer => {
        self.props.handleGoToPage("");
      })
      .catch(error => {
        self.props.handleUpdateLoaded(true);
        self.setState({ loaded: true, errors: error.errors });
      });

    this.check_load_percent_init();
  };

  check_load_percent_init = e => {
    const self = this;
    setTimeout(function() {
      const percent_upload = self.createRecommendationCall.percent_upload();
      self.setState({ percent_upload });
      self.check_load_percent();
    }, 3000);
  };

  check_load_percent = e => {
    if (this.props.loaded === false) {
      const self = this;
      setTimeout(function() {
        const percent_upload = self.createRecommendationCall.percent_upload();
        self.setState({ percent_upload });
        self.check_load_percent();
      }, 3000);
    }
  };
}

export default CreateRecommendationPage;



// WEBPACK FOOTER //
// ./src/components/create_recommendation/create_recommendation_page.jsx